export const PROMO_ACTIVE_PERIOD_TITLE = 'Только';
export const PROMO_ACTIVE_PERIOD_FROM = 'с';
export const PROMO_ACTIVE_PERIOD_TO = 'по';
export const PROMO_ACTIVE_PERIOD_TITLE_BIG = 'Акция действует ';
